export class ProductPackagingDto {
  packType: string;
  packSize = 0;
  caseCount = 0;
  id?: string;

  constructor(d?: ProductPackagingDto) {
    if (!d) {
      return;
    }

    this.packType = d.packType;
    this.packSize = d.packSize || 0;
    this.caseCount = d.caseCount || 0;
    this.id = d.id;
  }
}
